<template>
    <div>
        <scheduling-form
            v-if="schedulingForm"
            :scheduling="selectedScheduling"
            :disable-edit-start-date="disableEditStartDate"
            :is-scheduling-form-edit="isSchedulingFormEdit"
            :channel="channel"
            :min-duration-parameter="minDurationParameter"
            @leave-form-view="leaveForm"
            @scheduling-created="schedulingCreated"
        ></scheduling-form>
        <div
            v-else
        >   
            <div class="scheduling-list">
                <el-popover
                    popper-class="gcmcn-popper export-popper"
                    placement="bottom"
                    width="100"
                    trigger="hover"
                    content="CSV EXPORT"
                    :visible-arrow="false"
                >
                    <el-button
                        slot="reference"
                        class="button-export"
                        icon="el-icon-download"
                        type="primary"
                        @click="openDownloadCsvModal"
                    >
                    </el-button>
                </el-popover>
                <modal-export-csv
                    ref="open-download-csv-modal"
                    :channel="channel"
                ></modal-export-csv>
                <el-button
                    class="button-add"
                    icon="el-icon-plus"
                    type="primary"
                    @click="createNewScheduling"
                >
                </el-button>
                <div class="filter-container">
                    <p class="schedulings-count">{{filteredSchedulings.length}} Schedulings</p>
                    <gcmcn-filters
                        ref="gcmcn-filters"
                        :filter-values="[dateRange]"
                        @reset-filters="resetFilters"
                    >
                        <date-picker-range ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
                    </gcmcn-filters>
                </div>
                <div
                    v-if="filteredSchedulings.length > 0"
                    class="scheduling-card-container"
                    :style="{height: `calc(100vh - ${this.usedHeight}px)`}"
                >
                    <scheduling-card
                        v-for="scheduling in filteredSchedulings"
                        :key="scheduling.uid"
                        :scheduling="scheduling"
                        @edit-scheduling="editScheduling"
                        @set-disable-edit-start-date="setDisabledEditStartDate"
                        @on-archived-reload="onArchiveReload"
                        @on-scheduling-stopped="onSchedulingStopped"
                    ></scheduling-card>
                </div>
                <div v-else class="list-empty">no schedulings</div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    DatePickerRange,
    GcmcnFilters,
} from 'gcmcn-common';
import {mapGetters} from 'vuex';
import moment from 'moment';
import SchedulingCard from './scheduling-card.vue';
import SchedulingForm from './scheduling-form.vue';
import ModalExportCsv from './modal-export-csv.vue';
export default {

    name: 'Index',
    components:{
        SchedulingCard,
        SchedulingForm,
        DatePickerRange,
        GcmcnFilters,
        ModalExportCsv
    },
    props:{
        schedulings:{
            type: Array,
            reqiured: true
        },
        channel:{
            type: Object,
            reqiured: true
        },
        minDurationParameter:{
            type: Number,
            required: true,
        },
    },
    data () {
        return {
            schedulingForm: false,
            isSchedulingFormEdit: false,
            selectedScheduling: null,
            disabledEditStartDate: [],
            dateRange: '',
            usedHeight: 0,
            url:'scheduling/',
        };
    },
    computed:{
        ...mapGetters([
            'windowWidth'
        ]),
        filteredSchedulings(){
            let schedulings = this.schedulings.slice();
            if(this.dateRange.length > 0){
                // obbligé d'ajouter 1 jours car si le user selectionne par exemple le 30/07/2020 la valeur retournée sera 29/07/2020
                let start = moment.utc(this.dateRange[0]).set({hour: 0, minute: 0, second: 0}).add(1, 'days');
                let end = moment.utc(this.dateRange[1]).set({hour: 23, minute: 59, second: 59}).add(1, 'days');
                schedulings = schedulings.filter((scheduling) => {
                    const schedulingStartDate = scheduling.start_date;
                    const schedulingEndDate = scheduling.end_date;
                    return moment.utc(schedulingStartDate).isAfter(start) && moment.utc(schedulingEndDate).isBefore(end);
                });
            }
            return schedulings;
        },
        disableEditStartDate(){
            if(this.selectedScheduling){
                return this.disabledEditStartDate.includes(this.selectedScheduling.uid);
            }
            return false;

        }
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    methods:{
        openDownloadCsvModal(){
            this.$refs['open-download-csv-modal'].open();
        },
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        setDisabledEditStartDate(schedulingUid){
            if(!this.disabledEditStartDate.includes(schedulingUid)){
                this.disabledEditStartDate.push(schedulingUid);
            }
        },
        editScheduling(selectedScheduling){
            this.selectedScheduling = selectedScheduling;
            this.schedulingForm = true;
            this.isSchedulingFormEdit = true;
        },
        setDaterange (val){
            this.$set(this, 'dateRange', val);
        },
        resetFilters (){
            this.$refs['date-range'].clear();
        },
        leaveForm(){
            this.schedulingForm = false;
            this.isSchedulingFormEdit = false;
        },
        onArchiveReload(){
            this.updateDataList();
        },
        createNewScheduling(){
            this.schedulingForm = true;
        },
        schedulingCreated(){
            this.schedulingForm = false;
            this.updateDataList();
        },
        onSchedulingStopped(){
            this.updateDataList();
        },
        updateDataList(){
            this.$emit('update-data-list');
        },
        setViewHeight(){
            this.$nextTick(()=>{
                this.computeFilterHeight();
            });
        }
    },
};
</script>

<style lang="css" scoped>
.schedulings-count{
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: #BBBBBB;
    margin-bottom: 20px;
}
.button-add{
    position: absolute;
    right: 0;
    top:  0;
    width: 24px;
    height: 24px;
    float: right;
    background: #409EFF;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin: 1.5rem 2rem;
}
.filter-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.scheduling-list{
    padding: 3rem 2rem;
    border-radius: 5px;
    background: linear-gradient(180deg, #222222 0%, #111111 61.77%);
}
.scheduling-card-container{
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 5px;
}
.button-export{
    position: absolute;
    left: 0;
    top:  0;
    width: 24px;
    height: 24px;
    float: right;
    background: #409EFF;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin: 1.5rem 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/SchedulingsView/index.vue